import {Component, EventEmitter, Injectable, Input, OnInit, Output} from '@angular/core';
import {AppelOfferAcheteurObjectSearch} from '../../../../../domain/appel-offer-ach/appel-offer-acheteur';
import {MatTableDataSource} from '@angular/material/table';
import {TranslateService} from '@ngx-translate/core';
import {AppTranslateService} from '../../../../../modules/services/translate/app-translate.service';
import {AppeloffreAcheteurService} from '../../../../../modules/services/acheteur/appel-offer/appel-offer-ach.service';
import {ToastService} from '../../../../../modules/toast/toast.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DateFormatTimePipe} from '../../../../../modules/pipes/pipes/date-formatwithtime.pipe';
import {MatDialog} from '@angular/material/dialog';
import {DialogHistoriqueDelaiFoComponent} from './dialog-historique-delai-fo/dialog-historique-delai-fo.component';
import {
    DialogListAttachFilesComponent
} from '../../acheteur/appel-offre/proc-passa/ouverture-offres/dialog-list-attach-files/dialog-list-attach-files.component';
import {AppeloffreService} from '../../../../../modules/services/appel-offre/appeloffre.service';
import {HistoriquedelaiService} from '../../../../../modules/services/fournisseur/historiquedelai/historiquedelai.service';
import {ConfirmDialogService} from '../../../../../modules/services/ui/confirm-dialog.service';

@Injectable({
    providedIn: 'root',
})
export class Transferid {
    private data;

    constructor() {
    }

    setData(data) {
        this.data = data;
    }

    getData() {
        return this.data;
    }

    clearData() {
        this.data = undefined;
    }
}

@Component({
    selector: 'app-details-offre-fornisseur',
    templateUrl: './details-offre-fornisseur.component.html',
    styleUrls: ['./details-offre-fornisseur.component.css'],
})
export class DetailsOffreFornisseurComponent implements OnInit {
    checkIfAllBidClsArePublishedFlag: boolean = false;
    @Input() withopar = true;
    @Output() details = new EventEmitter<AppelOfferAcheteurObjectSearch>();
    data2 = [{bidcls: '-', licenseCd: '-'}];
    @Input() detailsoffre;
    @Input()
    labels = [
        'N° d\'avis d\'AO',
        'Date et heure de publication',
        'Nouvelle insertion ou modification',
        'Appel doffres en ligne : oui ou non',
        'Type',
        'N° de référence',
        'Nom de lacheteur public',
        'Objet de l\'appel d\'offres (arabe)',
        'Objet de l\'appel d\'offres (français)',
        'Objet de l\'appel d\'offres (anglais)',
    ];
    lables2 = [
        'Type de commande',
        'Nature du prix',
        'Marché cadre',
        'Marché général',
        'Demande de financement',
        'Mode de passation',
        'Source de financement',
        'Possibilité de groupement',
        'Date et heure du commencement d\'envoi des offres',
        'Dernier délai de réception des offres',
        'Date et heure d\'ouverture des offres',
        'Lieu d\'ouverture des offres',
        'Méthodologie d evaluation',
        'Prix du cahier des charges',
        'Type de cautionnement provisoire',
        'Département (arabe)',
        'Le département',
        'Département (anglais)',
        'Responsable',
        'Adresse de réception des offres (AR)',
        'Adresse de réception des offres (FR)',
        'Adresse de réception des offres (EN)',
        /*    "Président de la commission d'évaluation ou d'achats",
            "Président de la commission des marchés ou d'achats",*/
    ];
    labelc = ['honer'];
    dataColumns2 = [
        'bizKindStrFr',
        'priceTypeStrFr',
        'frameworkYn',
        'generalYn',
        'financingYn',
        'procedureTypeStrFr',
        'financialMethodStrFr',
        'consorYnStrFr',
        'bdRecvStartDt',
        'bdRecvEndDt',
        'bdOpenDt',
        'executionPlaceStrFr',
        'evalMethodStrFr',

        'biddingDocPriceCurr',
        'guaranteeTypeStrFr',
        'bdDepartAr',
        'bdDepartFr',
        'bdDepartEn',
        'staffNm',
        'bdRecvAddrsAr',
        'bdRecvAddrsFr',
        'bdRecvAddrsEn',
        /*    "examChmanId",
            "procChmanId",*/
    ];

    dataColumnsAr2 = [
        'bizKindStrAr',
        'priceTypeStrAr',
        'frameworkYn',
        'generalYn',
        'financingYn',
        'procedureTypeStrAr',
        'financialMethodStrAr',
        'consorYnStrAr',
        'bdRecvStartDt',
        'bdRecvEndDt',
        'bdOpenDt',
        'executionPlaceStrAr',
        'evalMethodStrAr',

        'biddingDocPriceCurr',
        'guaranteeTypeStrAr',
        'bdDepartAr',
        'bdDepartFr',
        'bdDepartEn',
        'staffNm',
        'bdRecvAddrsAr',
        'bdRecvAddrsFr',
        'bdRecvAddrsEn',
        /*    "examChmanId",
            "procChmanId",*/
    ];
    dataColumnsEn2 = [
        'bizKindStrEn',
        'priceTypeStrEn',
        'frameworkYn',
        'generalYn',
        'financingYn',
        'procedureTypeStrEn',
        'financialMethodStrEn',
        'consorYnStrEn',
        'bdRecvStartDt',
        'bdRecvEndDt',
        'bdOpenDt',
        'executionPlaceStrEn',
        'evalMethodStrEn',
        'biddingDocPrice',
        'biddingDocPriceCurr',
        'guaranteeTypeStrEn',
        'bdDepartAr',
        'bdDepartFr',
        'bdDepartEn',
        'bdRecvAddrsAr',
        'bdRecvAddrsFr',
        'bdRecvAddrsEn',
        'examChmanId',
        /*    "procChmanId",
            "bidInstCd",*/
    ];

    label = 'general_information';
    label2 = 'Informations sur AO';
    data: AppelOfferAcheteurObjectSearch[] = [];
    transposedData = [];
    displayedColumns = [];
    @Input()
    dataColumns = [
        'bidNo',
        'publicDt',
        'regTypeStrFr',
        'onOffTypeStrFr',
        'internationalBidYnStrFr',
        'refNo',
        'bidInstNm',
        'bidNmAr',
        'bidNmFr',
        'bidNmEn',
    ];
    @Input()
    dataColumnsAr = [
        'bidNo',
        'publicDt',
        'regTypeStrAr',
        'onOffTypeStrAr',
        'internationalBidYnStrAr',
        'refNo',
        'bidInstNm',
        'bidNmAr',
        'bidNmFr',
        'bidNmEn',
    ];
    @Input()
    dataColumnsEn = [
        'bidNo',
        'publicDt',
        'onOffType',
        'internationalBidYnStrEn',
        'refNo',
        'bidNmAr',
        'bidNmFr',
        'bidNmEn',
    ];

    dataSource: MatTableDataSource<any>;
    @Input() langue: string;
    seq: string;
    list: any;
    checkFlags: any = {};
    id: number;
    @Input() epBidMasterId: number;
    listAgrement = [];
    isLoading = false;
    columns = ['condition'];
    datac = {condition: 'rrrrrr'};
    isAnnoncCardDisplayed: boolean = true;

    constructor(
        private translate: TranslateService,
        private appTranslateService: AppTranslateService,
        private achservice: AppeloffreAcheteurService,
        private toastService: ToastService,
        private activatedRoute: ActivatedRoute,
        private transferid: Transferid,
        private dateFormatTimePipe: DateFormatTimePipe,
        private dialoog: MatDialog,
        private router: Router,
        private offerservice: AppeloffreService,
        private historique: HistoriquedelaiService,
        private confirm: ConfirmDialogService
    ) {
        this.langue = this.getlang();
    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params) => {
            this.epBidMasterId = params.epBidMasterId;
            this.id = params.bidNo;
            this.transferid.setData(this.epBidMasterId);
        });

        this.getdetail();
        this.getAgrement();
    }

    getAgrement() {
        this.achservice.getAgrementListFour(this.id).subscribe({
            next: (getagre) => {
                
                this.listAgrement = getagre;
                
            },
            error: () => {
                this.isLoading = false;
                this.toastService.error('server_error');
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }

    initColumnsAnddataColumns2(data) {
        
        if (data.procedureType === '3') {
            this.lables2.splice(8, 0, 'Dernier délai réception dossiers candidature');
            this.dataColumns2.splice(8, 0, 'pqRecvEndDtStr2');
            this.dataColumnsAr2.splice(8, 0, 'pqRecvEndDtStr2');
            this.dataColumnsEn2.splice(8, 0, 'pqRecvEndDtStr2');
            this.lables2.splice(9, 0, 'Date heure ouverture dossiers candidature');
            this.dataColumns2.splice(9, 0, 'pqOpenDtStr2');
            this.dataColumnsAr2.splice(9, 0, 'pqOpenDtStr2');
            this.dataColumnsEn2.splice(9, 0, 'pqOpenDtStr2');
        } else if (data.procedureType === '4') {
            this.lables2.splice(
                8,
                0,
                'Dernier délai réception propositions techniques'
            );
            this.dataColumns2.splice(8, 0, 'tpRecvEndDtStr2');
            this.dataColumnsAr2.splice(8, 0, 'tpRecvEndDtStr2');
            this.dataColumnsEn2.splice(8, 0, 'tpRecvEndDtStr2');
            this.lables2.splice(9, 0, 'Date heure ouverture propositions techniques');
            this.dataColumns2.splice(9, 0, 'tpOpenDtStr2');
            this.dataColumnsAr2.splice(9, 0, 'tpOpenDtStr2');
            this.dataColumnsEn2.splice(9, 0, 'tpOpenDtStr2');
        }
    }

    getdetail() {
        this.achservice
            .getDetailAppelOffreFou(this.transferid.getData())
            .subscribe({
                next: (data) => {
                    this.seq = data.bidModSeq;
                    data.procChmanId = data.procChmanIdStr + '-' + data.procChmanId;
                    data.examChmanId = data.examChmanIdStr + '-' + data.examChmanId;
                    data.biddingDocPriceCurr =
                        data.biddingDocPrice + '' + data.biddingDocPriceCurr;
                    this.details.emit(data);
                    this.detailsoffre = data;
                    this.getlist(this.detailsoffre.bidNo, this.detailsoffre.bidModSeq);
                    this.getFlags('resultatOuvPublishedFour');
                    this.getFlags('soumissionaireRetenu');
                    
                    if (data.generalYn == 'Y') {
                        data.generalYn = 'Oui';
                    }
                    if (data.generalYn == 'N') {
                        data.generalYn = 'Non';
                    }
                    if (data.frameworkYn == 'Y') {
                        data.frameworkYn = 'Oui';
                    }
                    if (data.frameworkYn == 'N') {
                        data.frameworkYn = 'Non';
                    }
                    if (data.financingYn == 'Y') {
                        data.financingYn = 'Avec';
                    }
                    if (data.financingYn == 'N') {
                        data.financingYn = 'Sans';
                    }
                    const t = this.dateFormatTimePipe.transform(data.publicDt);
                    data.publicDtTimestamp = data.publicDt;

                    if (data.pqRecvEndDt) {
                        data.pqRecvEndDtStr2 = this.dateFormatTimePipe.transform(
                            data.pqRecvEndDt
                        );
                    }
                    if (data.pqOpenDt) {
                        data.pqOpenDtStr2 = this.dateFormatTimePipe.transform(
                            data.pqOpenDt
                        );
                    }
                    if (data.tpRecvEndDt) {
                        data.tpRecvEndDtStr2 = this.dateFormatTimePipe.transform(
                            data.tpRecvEndDt
                        );
                    }
                    if (data.tpOpenDt) {
                        data.tpOpenDtStr2 = this.dateFormatTimePipe.transform(
                            data.tpOpenDt
                        );
                    }

                    data.bdRecvStartDt = this.dateFormatTimePipe.transform(
                        data.bdRecvStartDt
                    );
                    data['bdRecvEndDtTimestamp'] = data.bdRecvEndDt;
                    data.bdRecvEndDt = this.dateFormatTimePipe.transform(
                        data.bdRecvEndDt
                    );

                    data.bdOpenDt = this.dateFormatTimePipe.transform(data.bdOpenDt);
                    data.publicDt = t;

                    this.data = [data];
                    this.initColumnsAnddataColumns2(data);
                    
                },
            });
    }

    getlist(shopno, shopmodseq) {
        this.historique.getlistmodifications(shopno, shopmodseq).subscribe((x) => {
            this.list = x;
        });
    }

    open() {
        if (this.list.length == 0) {
            this.confirm.error('no_modif');
        } else if (this.list.length > 0) {
            const dialogRef = this.dialoog.open(DialogHistoriqueDelaiFoComponent, {
                disableClose: true,
                direction: this.appTranslateService.getDir(),
                data: {
                    shopNo: this.id,
                    shopModSeq: this.detailsoffre.bidModSeq,

                    data: this.detailsoffre,
                },
                width: '70vw',
            });
        }
    }

    public openPageEmail() {
        //To redirect page offerdetailsFo
        this.router.navigate([
            '/fournisseur/offres/offerdetailsFo/email/' +
            this.epBidMasterId +
            '/' +
            this.id,
        ]);
    }

    openDialogListAttachedFiles(data: any) {
        
        const bidInfos = () => {
            if (data.code === 'listAnnoncesAttachFiles') {
                return {
                    bidNo: data.element.bidNo,
                    bidModSeq: data.element.bidModSeq,
                    // funcType:  data.element.funcType,
                    funcType: '1',
                };
            }
        };
        
        const dialogRef = this.dialoog.open(DialogListAttachFilesComponent, {
            disableClose: true,
            width: '90rem',
            direction: this.appTranslateService.getDir(),
            data: {
                dialogTitle: 'Pièces jointes',
                cardTitle: 'Liste pièces jointes',
                bidInfos: {
                    ...bidInfos(),
                    code: data.code,
                },
            },
        });
        dialogRef.afterClosed().subscribe((result) => {

        });
    }

    getFlags(flag) {
        const reqParams = {
            bidNo: this.detailsoffre.bidNo,
            bidModSeq: this.detailsoffre.bidModSeq,
        };
        this.offerservice.getResultData(flag, null, reqParams, 'fournisseur', 'GET').subscribe({
            next: (response) => {
                
                if (response['code'] == '200') {
                    this.checkFlags[flag] = response['payload'] === 'Y';
                } else {
                    this.toastService.error('server_error');
                }
            },
            error: (e) => {
                console.error(e);
                this.toastService.error('server_error');
            },
            complete: () => {

            }
        });
    }

    checkIfAllBidClsArePublished() {
        
        const reqParams = {
            bidNo: this.detailsoffre.bidNo,
            bidModSeq: this.detailsoffre.bidModSeq,
        };
        this.offerservice.checkIfAllBidClsArePublished(reqParams).subscribe({
            next: (response) => {
                
                if (response['code'] == '200') {
                    this.checkIfAllBidClsArePublishedFlag = response['payload'] === 'Y';
                } else {
                    this.toastService.error('server_error');
                }
            },
            error: (e) => {
                console.error(e);
                this.toastService.error('server_error');
            },
            complete: () => {
            },
        });
    }

    openFicheListSoumissionaires() {
        if (this.checkFlags['soumissionaireRetenu']) {
            // this.router.navigate([this.router.url, 'listSoumissionaires']);
            this.router.navigate([
                '/fournisseur/offres/offerdetailsFo',
                this.epBidMasterId,
                this.id,
                'listSoumissionaires',
            ]);
        }
    }

    openFicheResultatOuverture() {
        if (this.checkFlags['resultatOuvPublishedFour']) {
            
            // this.router.navigate([this.router.url, 'listSoumissionaires']);
            this.router.navigate([
                '/fournisseur/offres/offerdetailsFo',
                this.epBidMasterId,
                this.id,
                'resultatouverture',
            ]);
        }
    }
}
